export enum RouteQuery {
  ELEMENT_ID = "elementId",
}
